import { defineComponent, useAttrs, ref, provide, computed, watch, createBlock, openBlock, unref, mergeProps, withCtx, createVNode, renderSlot } from "vue";
import { toTypedSchema } from "../../../../node_modules/.pnpm/@vee-validate_zod@4.15.0_vue@3.5.16_typescript@5.8.3__zod@3.25.46/node_modules/@vee-validate/zod/dist/vee-validate-zod.js";
import { Form } from "vee-validate";
import { object } from "zod";
import { LAYOUT_INJECTION_KEY } from "../injectionKeys.js";
import { isTypedSchema } from "../utils.js";
import _sfc_main$1 from "./FormWrapperContext.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormWrapper",
  props: {
    class: {},
    schema: {},
    validationSchema: {},
    layout: { default: "vertical" }
  },
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props, emits = __emit, attrs = useAttrs(), forwarded = useForwardPropsEmits(props, emits), layoutRef = ref(props.layout);
    provide(LAYOUT_INJECTION_KEY, layoutRef);
    const validationSchema = computed(() => {
      const schema = props.validationSchema ?? props.schema;
      if (schema)
        return isTypedSchema(schema) ? schema : toTypedSchema(object(schema));
    }), formRef = ref();
    return __expose(() => {
      var _a;
      return (_a = formRef.value) == null ? void 0 : _a.context;
    }), watch(() => props.layout, (newLayout) => layoutRef.value = newLayout), (_ctx, _cache) => (openBlock(), createBlock(unref(Form), mergeProps({ ...unref(forwarded), ...unref(attrs) }, {
      class: props.class,
      "validation-schema": validationSchema.value
    }), {
      default: withCtx((formSlotProps) => [
        createVNode(_sfc_main$1, {
          ref_key: "formRef",
          ref: formRef,
          "form-slot-props": formSlotProps
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 2
        }, 1032, ["form-slot-props"])
      ]),
      _: 3
    }, 16, ["class", "validation-schema"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormWrapper.js.map
